import { useState, useRef, useEffect } from 'react';
import { HelpCircle } from 'lucide-react';

interface HelpTooltipProps {
  content: string;
  position?: 'top' | 'right';
}

export default function HelpTooltip({ content, position = 'top' }: HelpTooltipProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const posClass =
    position === 'right'
      ? 'left-full top-1/2 -translate-y-1/2 ml-2'
      : 'bottom-full left-1/2 -translate-x-1/2 mb-2';

  return (
    <div
      className="relative inline-flex"
      ref={ref}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        onClick={() => setOpen(!open)}
        className="text-muted-foreground hover:text-gold transition-colors"
        type="button"
      >
        <HelpCircle size={14} />
      </button>
      {open && (
        <div
          className={`absolute z-50 w-64 rounded-lg border border-gold/30 bg-[#1c1c1f] p-3 text-xs leading-relaxed text-foreground shadow-lg ${posClass}`}
        >
          {content}
        </div>
      )}
    </div>
  );
}
